import {Injectable} from '@angular/core';
import {PartnerDataService} from './partnerData.service';
import {
    AbstractDataServiceDtoSummaryAdapter
} from '../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter';
import {PartnerSummaryModel} from '../../../api/model/partnerSummary.model';
import {PartnerSummaryConverter} from '../../../api/converter/partnerSummary.converter';
import {PartnerModel} from '../../../api/model/partner.model';

@Injectable({ providedIn: 'root' })
export class PartnerSummaryDataServiceAdapter extends
    AbstractDataServiceDtoSummaryAdapter<PartnerSummaryModel, PartnerSummaryConverter, PartnerModel> {
    constructor(dataService: PartnerDataService, converter: PartnerSummaryConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): PartnerModel {
        return new PartnerModel();
    }
}
